var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"app-content"},[_vm._v("\n                  \n        "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendMessageCalculator()}}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-save"}),_c('span',{staticClass:"text"},[_vm._v("Send Message Calculator")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }